<script>
import { defineComponent } from "vue";
import PdfSlot from "../PdfSlot/PdfSlot.vue";
import PdfCartaPropostaProdutoCard from "./components/PdfCartaPropostaProdutoCard.vue";
import PdfCartaPropostaComponente from "./components/PdfCartaPropostaComponente.vue";
import PdfCartaPropostaQuantidadePreco from "./components/PdfCartaPropostaQuantidadePreco.vue";
import html2pdf from 'html2pdf.js';
const name = 'PdfCartaPropstaComComponentes'

export default defineComponent({
  name,

  components: { 
    PdfSlot,
    PdfCartaPropostaProdutoCard,
    PdfCartaPropostaComponente,
    PdfCartaPropostaQuantidadePreco
  }, 
  emits:['isLoading'],
  props: {
    cartaPropostaId:{
      type: String,
      default: ""
    },
    nomeClientePersonalizado:{
      type: String,
      default: ""
    },
    canDownloadPdf:{
      type: Boolean,
      default: false
    },

    openPdfNewTab:{
      type: Boolean,
      default: true,
    } 

   

   },

  mounted () { 
    //CARTA ANALITICA
    this.getPdfData().then(()=>this.canRender = true)

  },

  updated () { },

  data () {
    return {
      arrayOrcamentosInformacoes: [],
      nomeCliente:"",
      nomeRepresentante:"",
      canRender: false,
      valorIpi : 0,
      valorIcms : 0,
      valorPisCofinsFormatado:"",
      formaPagamento: "",
      nomeEmpresa:"",
      codigoCartaProposta:"", 
      observacaoNegociacao:"",
      observacaoGeral:"",
     }
  },

  methods: { 
    async getPdfData(){
      this.$emit('isLoading',true)
      await this.getResumoFinalCartaProposta()
      await this.getPorcentagensImpostos()
      this.$emit('isLoading',false)
    },

    async getResumoFinalCartaProposta() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetResumoFinalCartaProposta/${this.cartaPropostaId}`,
      })
      .then((response) => {  
        this.nomeCliente = response.data.data.nomeCliente;
        this.nomeRepresentante = response.data.data.nomeRepresentante;
        this.arrayOrcamentosInformacoes =  response.data.data.orcamentosInformacoes
        this.observacaoGeral = this.arrayOrcamentosInformacoes[0].observacaoGeral
        this.observacaoNegociacao = this.arrayOrcamentosInformacoes[0].observacaoNegociacao
        this.formaPagamento = response.data.data.formaDePagamento
        this.nomeEmpresa = response.data.data.nomeEmpresa
        this.codigoCartaProposta = `#${response.data.data.codigoCarta}` 
      })
      .catch(() => {
      })      
    },

    async getPorcentagensImpostos() {
      await this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `CartaProposta/GetPorcentagensImpostos/${this.cartaPropostaId}`,
      })
      .then((response) => {
        this.valorIpi = response.data.data.porcentagemIpi
        this.valorIcms = response.data.data.porcentagemIcms
        this.valorPisCofinsFormatado = response.data.data.porcentagemPisCofinsFormatado   
        
        
      })
      .catch(() => {
      });
    },

    orcamentoComponenteArrayLinha(orcamentoComponentes){
      let arrayLinha = []
      let arrayComponentes = orcamentoComponentes
      
      
      let arrayLinhaComponente = []
      
      for (let index = 0; index < arrayComponentes.length; index++) {
        
        arrayLinhaComponente.push(arrayComponentes[index])
        
        if (index % 2 !== 0) {
          arrayLinha.push(arrayLinhaComponente)
          arrayLinhaComponente = []
        }
      }

      if (arrayLinhaComponente.length > 0) {
        arrayLinha.push(arrayLinhaComponente)
      }

      return arrayLinha
    },

    createImageHeaderFooter(imgHref) {
      const img = document.createElement("img");	
      img.src = imgHref;
      img.style.border="none"
      return img
    },

    pdfCallback(el,pdfConfig){
      const pdf = el
      const config = pdfConfig
      const headerImage = new URL("@/assets/imgs/Cabecalho_PDF_CartaProposta_PNG.png", import.meta.url)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      
      const headerImageFirstPage = new URL("@/assets/imgs/Cabecalho_Carta_Proposta_1_PNG.png", import.meta.url)
      const headerImageFirstPagePdf = this.createImageHeaderFooter(headerImageFirstPage.href)
      
      const footerImageLastPage = new URL("@/assets/imgs/Rodape_Orcamento_inicio_PNG.png", import.meta.url)
      const footerImageLastPagePdf = this.createImageHeaderFooter(footerImageLastPage.href)
      
      const footerImage = new URL("@/assets/imgs/Rodape_CartaProposta_PNG.png", import.meta.url)
      const footerPdf = this.createImageHeaderFooter(footerImage.href)
		


      html2pdf().from(pdf).set(config).toPdf().get('pdf')
      .then( (pdf) => {
        try{
          var totalPages = pdf.internal.getNumberOfPages();
          
          
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            if(i === 1){
              pdf.addImage(headerImageFirstPagePdf, 'Image-HTMLElement ', 0, 0, 210, 0 );
 
              if(this.nomeEmpresa.includes('NORDESTE')){

                pdf.setTextColor("#3f3f3f");
                pdf.setFontSize(12);
                pdf.setFont('Helvetica','normal');
                pdf.text("Carta-Proposta",155,10)

                pdf.setFont('Helvetica','bold');
                pdf.text(this.codigoCartaProposta,185,10)						

                pdf.setLineWidth(0.5);
                pdf.setDrawColor("#4f2c19");
                pdf.line(180, 16, 200, 16);

                pdf.setFont('Helvetica','bold');
                pdf.setFontSize(12);
                pdf.text(this.nomeEmpresa,125,24)		
              }		
              else{
                pdf.setTextColor("#3f3f3f");
                pdf.setFontSize(12);
                pdf.setFont('Helvetica','normal');
                pdf.text("Carta-Proposta",150,10)
                
                pdf.setFont('Helvetica','bold');
                pdf.text(this.codigoCartaProposta,180,10)						
                
                pdf.setLineWidth(0.5);
                pdf.setDrawColor("#4f2c19");
                pdf.line(180, 16, 200, 16);

                pdf.setFont('Helvetica','bold');
                pdf.setFontSize(13);
                pdf.text(this.nomeEmpresa,145,24)		
              }	

            }else{
              pdf.addImage(headerPdf, 'Image-HTMLElement ', 0, 0, 210, 0 );
            }
            if(i < totalPages){
              pdf.addImage(footerPdf, 'Image-HTMLElement', 0, pdf.internal.pageSize.getWidth() + 79.2, 210, 0);

              pdf.setTextColor("#FFF");
              pdf.setFontSize(10);
              pdf.setFont('Helvetica','bold');
              pdf.text(this.diaHojeFormatado,170,294)

            }else{
              pdf.addImage(footerImageLastPagePdf, 'Image-HTMLElement', 0, pdf.internal.pageSize.getWidth()+71, 210, 0);
            }
           
          } 
        }
        catch (e) {
          console.error(e)
        }
        if(this.canDownloadPdf){
          pdf.save('CartaProposta_' + this.codigoCartaProposta + '_' + this.nomeCliente + '.pdf')
        }
        if(this.openPdfNewTab){
          window.open(pdf.output('bloburl'), '_blank')
        }
      })
    
    }

  },

  computed: { 
    diaHojeFormatado(){
      const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

        let today = new Date();
        return  today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
    },
  }, 


});
</script>

<template>
    <PdfSlot  v-if="canRender" :pdfCallback="pdfCallback">
      <div class="pdf-content">
        <h2>À {{ nomeCliente }}</h2>
        <p v-if="nomeClientePersonalizado"><em class="pronome-tratamento">A/Sr(a):</em> {{ ' '+nomeClientePersonalizado }} </p>
        <p> Conforme solicitado, seguem abaixo preços e condições para fornecimento, a saber </p>
        <div class="orcamento-container">
          <div class="orcamento-item" :class="{'orcamento-divisor':index > 0 }" v-for="orcamento,index in arrayOrcamentosInformacoes" :key="index">
                  
          <section>
            
            <h2 v-if="index > 0" >Orçamento: {{ orcamento.codigoOrcamento}}</h2>
            <div class="dados-produto">
              <PdfCartaPropostaProdutoCard
              :nomeProduto="orcamento.nomeProduto"
              :codigoOrcamento="orcamento.codigoOrcamento"
              :opcao="orcamento.descricaoOpcao"
              :descricaoFrete="orcamento.indicadorDeTipoFreteoEnum"
              />
            <div class="container-img-produto">
              <figure v-if="orcamento.temImagem">
                <img :src="orcamento.linkImagemProduto" class="img-sem-produto">
              </figure>
              <figure v-else class="img-indisponivel">
                <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-sem-produto">
                <p>Imagem Indisponível</p>
              </figure>
            </div>
          </div>
        </section>

          <PdfCartaPropostaQuantidadePreco :orcamentoDatas="orcamento.orcamentoDatas"/>
          
          <div>
            <table class="componente-table">
              <h2>Componentes</h2>
              <tr class="linha-componente" v-for="componentes,indexComp in orcamentoComponenteArrayLinha(orcamento.componentes)" :key="indexComp" >
                <PdfCartaPropostaComponente  
                v-for="componente,indexCompI in componentes"
                  :componente="componente" 
                  :index="orcamento.componentes.indexOf(componente)"
                  :key="indexCompI"
                />
            
              </tr>
            </table>
          </div>
          <section v-if="orcamento.observacaoProduto">
            <h2> OBSERVAÇÕES DO ORÇAMENTO</h2>
            <p>{{ ' - Solicitação: ' + orcamento.codigoOrcamento + ' - ' + orcamento.observacaoProduto }}</p>
          </section>
      </div>

      <section class="validate-pagamento">
          <img src="@/assets/imgs/Icone_Agenda.svg" class="validade-pagamento-img">
          <div class="validade-pagamento-item">
            <h3>VALIDADE DA PROPOSTA:</h3>
            <p>- 10 DIAS</p>
          </div>
        </section>

        <section  class="validate-pagamento">
          <img src="@/assets/imgs/Icone_Condicoes_Pagto.svg" class="validade-pagamento-img">
          <div class="validade-pagamento-item">
            <h3>CONDIÇÕES DE PAGAMENTO</h3>
            <p>{{ formaPagamento }}</p>
          </div>
        </section>

        <section class="tributacao">
          <h3>Tributações*</h3>
          <div class="icms-pis-ipi">
            <div class="tributacao-item">
              <em>ICMS</em>
              <p>{{ this.valorIcms !== 0 ? 'Incluso - '+ this.valorIcms + '%' : 'Diferido'}}</p>

            </div>
            <div class="tributacao-item">
              <em>PIS / COFINS </em>  
              <p>{{ this.valorPisCofinsFormatado  ? 'Incluso - '+ this.valorPisCofinsFormatado + '%' : 'Diferido'}}</p>
            </div>
            
            <div class="tributacao-item">
              <em>IPI</em>
              <p>{{ this.valorIpi == 0 ? 'Não Incluso - Preço acima + IPI' : 'Diferido'}}</p>
            </div>
          </div>
        </section>

        <section>
          <h2>COMPOSIÇÃO DA CARTA PROPOSTA</h2>
          <p> Possível suspensão ou diferimento dependerá da apresentação da declaração expressa, nos termos da legislação vigente. </p>   
          <br>                               
        </section>

      <section>
          <h2> OBSERVAÇÕES DA NEGOCIAÇÃO </h2>
          <p>  - De acordo com Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou menos.</p>
          <p>{{ this.observacaoGeral ? '- '+this.observacaoGeral : '' }}</p>
          <p>{{ this.observacaoNegociacao   ? '- '+this.observacaoNegociacao : '' }}</p>
        </section>
    </div>

        <section class="finalizacao">
          <h3>Representante :<em>{{ ' '+nomeRepresentante }}</em></h3>
          
          <p><em>Sem mais para o momento,<br></em>Nos colocamos a vosso dispor</p>
        </section>      
      </div>
    </PdfSlot>
</template>


<style scoped>


.pronome-tratamento{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
}
.page-break-after{
  page-break-after: always;
}



h1,h2,h3,p,li,ul,ol,figure{
  margin: 0;
  padding: 0;
}

p{
  font-size: .8rem;
}

h2{
  font-size: 1.2rem;
}

h3{
  font-size: 1rem;
}

h3 em {
  color: #8a8a8a;
  font-style: normal;
  font-weight: normal;
}

h2:after{
  content: "";
  display: block;
  width: 100px;
  height: 2px;
  background-color: #fcb315;
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.orcamento-divisor {
  width: 100%;
  padding-top: 1rem ;
  border-top: 1px dashed #3f3f3f87;
  
}

.finalizacao em{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;

}

.finalizacao{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}


.pdf-content{
  position: relative;
  font-family: 'MontSerrat';
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap:1rem;
  flex-direction: column;
  padding-top: 4rem;
}

.tributacao{
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f9f9f9;
  width: 100%;
  padding: 1rem;
  border-radius: 16px;
  font-size: .8rem;
}

.tributacao-item{
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  gap: .2rem;
}
.tributacao-item em{
  font-style: normal;
  font-weight: bold;
  color: #3f3f3f;
  
}

.icms-pis-ipi{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 1rem;

}

.validade-pagamento-img{
  width: 4rem;
  height: auto;
}

.validate-pagamento{
  background-color: #f9f9f9;
  width: 100%;
  padding: 1rem;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: flex;
  gap: 1rem;
}

.validade-pagamento-item{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1rem;

}

.validate-pagamento h3{
  color: #4f2c19 ;
}

.linha-componente{
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap:.5rem;
  /* padding-bottom: .5rem; */
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.componente-table{
  width: 100%;
}




.orcamento-item{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap:1rem;
}


.pdf-content p{
  color: #8a8a8a;
}

.pdf-content h1,.pdf-content h2,.pdf-content h3{
  color: #4f2c19;
  text-align: left;
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.pdf-content ul{
  list-style: none;
}

.orcamento-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  gap:1.2rem;
}



.dados-produto{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap:2rem;
  

}

.container-img-produto{
  
  height: 100%;
  padding: .5rem;
  width: 40%;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  
} 
.img-sem-produto{
  width: auto;
  height: 4rem;
  
}

.img-indisponivel{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: .5rem;
}

</style>
